import { request } from '@pb/utils'

import { FILTER_NAME } from 'features/account/hm-pay/duck/constants'

import { Errors } from './types'

const handleOauthExpiration = (data): any => {
  if (data?.oauthExpired) throw Error(Errors.OAUTH_EXPIRED)
  return data
}

export const fetchOmniCreditProfile = (): Promise<any> =>
  request.get('omniCreditProfile').then((res) => res.data)

export const fetchOmniCreditOrders = (
  size = 10,
  offset = 0,
  filterName: string,
): Promise<unknown> => {
  return request
    .get('omniCreditOrders', {
      params: {
        size,
        offset,
        filter: filterName === FILTER_NAME.TO_DO ? 'active' : undefined,
      },
    })
    .then((res) => handleOauthExpiration(res.data))
}

export const fetchOmniCreditOrder = async (orderId: string): Promise<unknown> => {
  if (!orderId) {
    throw new Error('orderId need to be provided to fetchOmniCreditOrder')
  }

  const res = await request.get(`omniCreditOrders/${orderId}`)
  return res.data
}

export const fetchOmniCreditSubscriptionCollections = async (
  size = 10,
  offset = 0,
  subscriptionId?: string,
): Promise<unknown> => {
  if (!subscriptionId) {
    throw new Error('subscriptionId needs to be provided to fetchOmniCreditSubscriptionCollections')
  }

  const res = await request.get(`omniCreditSubscriptions/${subscriptionId}/collections`, {
    params: {
      size,
      offset,
    },
  })
  return res.data
}

export const fetchOmniCreditInvoice = async (
  subscriptionId?: string,
  collectionId?: string,
): Promise<unknown> => {
  if (!subscriptionId || !collectionId) {
    throw new Error(
      'subscriptionId and collectionId needs to be provided to fetchOmniCreditInvoice',
    )
  }

  const res = await request.get(
    `omniCreditSubscriptions/${subscriptionId}/collections/${collectionId}/`,
  )
  return res.data
}

export const fetchOmniCreditMonthlyInvoiceOrders = async (
  subscriptionId?: string,
  collectionId?: string,
  size = 5,
  offset = 0,
): Promise<unknown> => {
  if (!subscriptionId || !collectionId) {
    throw new Error(
      'subscriptionId and collectionId needs to be provided to fetchOmniCreditCollectionOrders',
    )
  }

  const res = await request.get(
    `omniCreditSubscriptions/${subscriptionId}/collections/${collectionId}/orders`,
    {
      params: {
        size,
        offset,
      },
    },
  )
  return res.data
}
